var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',{staticClass:"d-flex justify-content-between align-items-center"},[_c('span',[_vm._t("lead"),_c('span',{staticClass:"text-body"},[_vm._v(_vm._s(_vm.cq.title))])],2),_vm._t("button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }